import morph from "../helpers/morph";

class ShopTheLookTabs extends HTMLElement {
  connectedCallback() {
    this.swipers = new Map();
    this.abortController = null;

    this.handleTabSelected = this.handleTabSelected.bind(this);
    this.handleAjaxRendered = this.handleAjaxRendered.bind(this);

    this.initialize();
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
    this.destroySwipers();
    this.abortController?.abort();
  }

  addEventListeners() {
    this.addEventListener("tab-component:tab-selected", this.handleTabSelected);

    document.addEventListener("product:ajax-rendered", this.handleAjaxRendered);
  }

  removeEventListeners() {
    this.removeEventListener("tab-component:tab-selected", this.handleTabSelected);

    document.removeEventListener("product:ajax-rendered", this.handleAjaxRendered);
  }

  initialize() {
    this.panels = Array.from(this.querySelectorAll("[data-shop-the-look-panel]"));

    this.mediaImages = Array.from(this.querySelectorAll("[data-shop-the-look-media]"));

    if (!this.panels.length) {
      return;
    }

    window.loadSwiper.then(({ Swiper, Navigation }) => {

      if (!this.isConnected) {
        return;
      }

      this.panels.forEach((panel) => {
        const container = panel.querySelector(".shop-the-look-tabs__container");

        if (!container) {
          return;
        }

        const prevEl = panel.querySelector("[data-shop-the-look-nav-previous]");

        const nextEl = panel.querySelector("[data-shop-the-look-nav-next]");

        const swiper = new Swiper(container, {
          modules: [Navigation],
          slidesPerView: 1.2,
          spaceBetween: 16,
          navigation:
            prevEl && nextEl
              ? {
                  prevEl,
                  nextEl,
                }
              : undefined,
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 24,
            },
          },
        });

        this.swipers.set(panel, swiper);
      });
    });
  }

  destroySwipers() {
    this.swipers?.forEach((swiper) => {
      swiper.destroy(true, true);
    });

    this.swipers?.clear();
  }

  handleTabSelected(event) {
    const selectedPanel = event.detail?.panel;

    if (!selectedPanel) {
      return;
    }

    this.swipers.get(selectedPanel)?.update();

    this.mediaImages.forEach((media) => {
      media.hidden = media.dataset.shopTheLookMediaFor !== selectedPanel.id;
    });
  }

  async handleAjaxRendered(event) {
    const sectionId = this.dataset.sectionId;
    const destinationUrl = event.detail?.url;

    if (!sectionId || !destinationUrl) {
      return;
    }

    this.abortController?.abort();
    this.abortController = new AbortController();

    const requestUrl = new URL(destinationUrl, window.location.origin);

    requestUrl.searchParams.set("section_id", sectionId);

    try {
      const response = await fetch(requestUrl.href, {
        method: "GET",
        headers: {
          Accept: "text/html",
          "X-Requested-With": "XMLHttpRequest",
        },
        signal: this.abortController.signal,
      });

      if (!response.ok) {
        throw new Error(`Shop the Look request failed with ${response.status}`);
      }

      const html = await response.text();

      const parsedDocument = new DOMParser().parseFromString(html, "text/html");

      const newElement = parsedDocument.querySelector(`shop-the-look-tabs[data-section-id="${CSS.escape(sectionId)}"]`);

      if (!newElement) {
        console.warn(
          "Shop the Look wrapper was not returned. Ensure Liquid always renders the custom-element wrapper.",
        );

        return;
      }

      this.replaceWith(newElement);
    } catch (error) {
      if (error.name === "AbortError") {
        return;
      }

      console.error("Shop the Look Tabs AJAX refresh failed:", error);
    }
  }
}

if (!customElements.get("shop-the-look-tabs")) {
  customElements.define("shop-the-look-tabs", ShopTheLookTabs);
}
